/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetLocationModifierGroups200ResponseItemsInner
 */
export interface GetLocationModifierGroups200ResponseItemsInner {
    /**
     * 
     * @type {string}
     * @memberof GetLocationModifierGroups200ResponseItemsInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetLocationModifierGroups200ResponseItemsInner
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetLocationModifierGroups200ResponseItemsInner
     */
    enabled: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetLocationModifierGroups200ResponseItemsInner
     */
    organizationEnabled: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof GetLocationModifierGroups200ResponseItemsInner
     */
    modifiers: number;
}

/**
 * Check if a given object implements the GetLocationModifierGroups200ResponseItemsInner interface.
 */
export function instanceOfGetLocationModifierGroups200ResponseItemsInner(value: object): value is GetLocationModifierGroups200ResponseItemsInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    if (!('organizationEnabled' in value) || value['organizationEnabled'] === undefined) return false;
    if (!('modifiers' in value) || value['modifiers'] === undefined) return false;
    return true;
}

export function GetLocationModifierGroups200ResponseItemsInnerFromJSON(json: any): GetLocationModifierGroups200ResponseItemsInner {
    return GetLocationModifierGroups200ResponseItemsInnerFromJSONTyped(json, false);
}

export function GetLocationModifierGroups200ResponseItemsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLocationModifierGroups200ResponseItemsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'enabled': json['enabled'],
        'organizationEnabled': json['organizationEnabled'],
        'modifiers': json['modifiers'],
    };
}

export function GetLocationModifierGroups200ResponseItemsInnerToJSON(json: any): GetLocationModifierGroups200ResponseItemsInner {
    return GetLocationModifierGroups200ResponseItemsInnerToJSONTyped(json, false);
}

export function GetLocationModifierGroups200ResponseItemsInnerToJSONTyped(value?: GetLocationModifierGroups200ResponseItemsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'enabled': value['enabled'],
        'organizationEnabled': value['organizationEnabled'],
        'modifiers': value['modifiers'],
    };
}

